import { endpoints } from '../../endpoints';
import { validateResponseData } from '../../utils';
import axiosInstance from '../../utils/axiosInstance';
import { getIdProtectResponseSchema, getPaymentProtectionInsuranceResponseSchema } from './schemas';

export const getIdProtect = async () => {
  const response = await axiosInstance.get(endpoints.SE.addonProducts.idProtect);

  return validateResponseData(getIdProtectResponseSchema, response.data);
};

export const getPaymentProtectionInsurance = async () => {
  const response = await axiosInstance.get(endpoints.SE.addonProducts.paymentProtectionInsurance);

  return validateResponseData(getPaymentProtectionInsuranceResponseSchema, response.data);
};
